// @ts-nocheck
import React, { Fragment } from "react";

import { Button } from "../../components/Button";
import { GridContainer, GridItem } from "../../components/Grid";
import { SimpleCard } from "../../components/Card";
import SearchBar from "../../components/SearchBar/SearchBar";
import Table from "../../components/Table/Table";

const PlaylistsTableContainer = ({
  dataList,
  searchString,
  setSearchString,
  isFetching,
  data,
  didWantToAddPlaylist,
  didWantToDeleteRow,
  didWantToCloneRow,
  didWantToEditRow,
}) => (
  <Fragment>
    <GridContainer style={{ marginBottom: 20 }}>
      {dataList.length > 5 && (
        <GridItem xs sm md lg>
          <SimpleCard cardStyle={{ marginTop: 0, marginBottom: 0 }}>
            <SearchBar value={searchString} onChange={setSearchString} />
          </SimpleCard>
        </GridItem>
      )}
    </GridContainer>
    <SimpleCard>
      <GridContainer>
        <GridItem xs={12}>
          <Button color="primary" onClick={didWantToAddPlaylist} small>
            Adicionar playlist <i className="fas fa-plus" />
          </Button>
        </GridItem>
        <GridItem xs={12}>
          <Table
            columns={[
              {
                Header: "Nome",
                accessor: "name",
              },
              {
                Header: "Grupo de Mídias",
                accessor: "files",
              },
              {
                Header: "Randômico",
                accessor: "isRandom",
              },
              {
                Header: "Mudo",
                accessor: "isMuted",
              },
            ]}
            isLoading={isFetching}
            data={data}
            actions={[
              {
                type: "delete",
                onClick: didWantToDeleteRow,
              },
              {
                type: "clone",
                onClick: didWantToCloneRow,
              },
              {
                type: "edit",
                onClick: didWantToEditRow,
              },
            ]}
          />
        </GridItem>
      </GridContainer>
    </SimpleCard>
  </Fragment>
);

export default PlaylistsTableContainer;
